import { css } from '@emotion/core'
import api from 'api'
import { Button, HFlow, Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { ArquivoTemporarioIdentificadorEnum } from 'graphql/types.generated'
import { useFirebase } from 'hooks/firebase/useFirebase'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { readFileError } from 'hooks/impressao/util-impressao'
import { usePubSub } from 'hooks/pubsub/usePubSub'
import React, { useState } from 'react'
import { isUndefinedOrNull } from 'util/checks'
import { ArquivoTemporarioFormato, relatoriosRecentesRecord } from 'view/arquivo/model-arquivo'

const TOOLTIP_MESSAGE = 'O relatório compara informações dos cadastros e retorna aqueles possivelmente duplicados.'

interface ExportarCadastrosDuplicadosButtonProps {
  identificadorModuloArquivo: ArquivoTemporarioIdentificadorEnum
}

export function ExportarCadastrosDuplicadosButton({
  identificadorModuloArquivo,
}: Readonly<ExportarCadastrosDuplicadosButtonProps>) {
  const theme = useTheme()
  const classes = createStyles(theme)
  const { analytics } = useFirebase()
  const { profissional } = useAcessoLotacaoOrEstagio()
  const { handleImpressao } = useHandleImpressao()
  const { topicBasePath, fileName } = relatoriosRecentesRecord[identificadorModuloArquivo]
  const usuarioId = profissional?.usuario?.id

  const [isLoading, setIsLoading] = useState(false)

  usePubSub<ArquivoTemporarioFormato>({
    topic: `/${topicBasePath}/${usuarioId}`,
    onMessage: (responseBody) => {
      if (!isUndefinedOrNull(responseBody.arquivo)) {
        const arquivoTemporario = new Uint8Array(responseBody.arquivo)
        handleImpressao({
          blob: new Blob([arquivoTemporario]),
          file: `${fileName}.${responseBody.formato.toLocaleLowerCase()}`,
          dateFormat: 'yyyy-MM-dd-HH-mm',
        })
        setIsLoading(false)
      }
    },
  })

  const handleClickExportarCadastrosDuplicados = () => {
    analytics.logEvent('exportar-cadastros-duplicados')
    setIsLoading(true)
    api.exportarCadastrosDuplicados.exportarCSV().catch(readFileError)
  }

  return (
    <HFlow hSpacing={0.8} alignItems='center'>
      <Tooltip text={TOOLTIP_MESSAGE} style={classes.tooltip}>
        <Icon icon='infoCircleFilled' size={1} />
      </Tooltip>
      <Button
        kind='primary'
        skin='outline'
        size='small'
        style={classes.button}
        onClick={handleClickExportarCadastrosDuplicados}
        loading={isLoading}
      >
        Exportar possíveis duplicatas
      </Button>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  tooltip: css`
    background: ${theme.pallete.gray.c20};
  `,
  button: css`
    padding: 0.25rem 1.5rem;
  `,
})
